import { render, staticRenderFns } from "@/components/Layout/Menu/Reportes/Reportes_cargas/Reportes_cargas.html?vue&type=template&id=45f96f10&scoped=true&"
import script from "@/components/Layout/Menu/Reportes/Reportes_cargas/Reportes_cargas.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Reportes/Reportes_cargas/Reportes_cargas.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Reportes/Reportes_cargas/Reportes_cargas.css?vue&type=style&index=0&id=45f96f10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f96f10",
  null
  
)

export default component.exports